import { gql } from '@apollo/client';

export default gql`
  fragment PaymentsProduct on Product {
    uuid
    itemRef
    loyaltyPoints
    price: priceWithCurrency
    originalPrice
    name
    code
    currency
    isSuspended
    isPlaceholder
    externalTicketNumber
    externalProductReference
    isExpired
    cancelled: isCancelled
    provisional
    canBeCancelled
    tariffDetails {
      tariffCode
    }
    confirmedTimestamp
    voidTimestamp
    expiryTimestamp
    passenger {
      id
      type
      travelDocumentsRequired {
        travelDocumentType
        required
      }
    }
    discounts {
      voucherId
    }
    passengerId
  }
`;
